import React, { FC, useEffect, useState } from 'react';
import { Typography, Accordion, AccordionSummary, AccordionDetails, Button, Link } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
import SaveIcon from '@material-ui/icons/Save';
import { useParticipantsRankAndAwardByCalendarLazyQuery } from '../../../../api';

const useStyles = makeStyles({
  row: {
    display: 'flex',
  },
  btn: {
    padding: '5px 5px',
    minWidth: '15px',
  },
  tinyIcon: {
    fontSize: 18,
  },
  icon: {
    fontSize: 20,
  },
  tableHead: {
    fontWeight: 'bold',
  },
  header: {
    fontWeight: 600,
    fontSize: 15,
    letterSpacing: 1.2,
  },
});

const columnMain = [
  {
    name: 'calendarName',
    label: 'Название календаря',
    options: {
      filter: false,
      display: true,
      sort: false,
    },
  },
  {
    name: 'totalAmountWithoutValidRank',
    label: 'Кол-во участников без разряда',
    options: {
      filter: false,
      display: true,
      sort: false,
    },
  },
  {
    name: 'totalAmount',
    label: 'Итого кол-во участников',
    options: {
      filter: false,
      display: true,
      sort: false,
    },
  },
];

const columnYear = [
  {
    name: 'name',
    label: 'Разряд / звание',
    options: {
      filter: false,
      display: true,
      sort: false,
    },
  },
  {
    name: 'amount',
    label: 'Количество участников',
    options: {
      filter: false,
      display: true,
      sort: false,
    },
  },
];

const columnEvent = [
  {
    name: 'eventName',
    label: 'Название спортивного мероприятия',
    options: {
      filter: false,
      display: true,
      sort: false,
    },
  },
  {
    name: 'sports',
    label: 'Виды спорта мероприятия',
    options: {
      filter: false,
      display: true,
      sort: false,
      customBodyRender: (data = []) => {
        return <>{data.join(', ')}</>;
      },
    },
  },
  {
    name: 'disciplineGroups',
    label: 'Группы дисциплин мероприятия',
    options: {
      filter: false,
      display: true,
      sort: false,
      customBodyRender: (data = []) => {
        return <>{data.join(', ')}</>;
      },
    },
  },
  {
    name: 'totalAmountWithoutValidRank',
    label: 'Кол-во участников без разряда',
    options: {
      filter: false,
      display: false,
      sort: false,
    },
  },
  {
    name: 'totalAmount',
    label: 'Итого кол-во участников',
    options: {
      filter: false,
      display: false,
      sort: false,
    },
  },
  {
    name: 'total',
    label: ' ',
    options: {
      filter: false,
      display: false,
      sort: false,
    },
  },
];

const ClassificationUsers: FC<{ readonly?: boolean; id?: string }> = ({ readonly, id }) => {
  const classes = useStyles();

  const [dataTable, setDataTable] = useState();
  // @ts-ignore
  const [fetch, { data, loading, refetch }]: any = useParticipantsRankAndAwardByCalendarLazyQuery({
    fetchPolicy: 'no-cache',
    variables: { id },
  });
  const DOWNLOAD_LINK = process.env.REACT_APP_BACKEND_URI?.replace('/graphql', '');
  useEffect(() => {
    if (id) {
      fetch();
    }
  }, [fetch, id]);
  return (
    <Accordion key="Спортивная квалификация участников" style={{ width: '100%', marginBottom: 15 }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`Спортивная квалификация участников-content`}
        id={`Спортивная квалификация участников-header`}
      >
        <Grid container spacing={2} justify="space-between" alignItems="center">
          <Grid item>
            <Typography className={classes.header} color="primary">
              Спортивная квалификация участников
            </Typography>
          </Grid>
          <Grid item onClick={(e) => e.stopPropagation()}></Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails style={{ flexDirection: 'column' }}>
        <Link href={`${DOWNLOAD_LINK}/reports/sporting-event-participants-by-rank/${id}`}>
          <Button size="small" variant="outlined" color="primary">
            <SaveIcon />
          </Button>
        </Link>
        <MUIDataTable
          title={''}
          data={[data?.aggregateParticipantsRankAndAwardByCalendar] || []}
          columns={columnMain}
          options={{
            filter: false,
            search: false,
            pagination: false,
            selectableRowsHideCheckboxes: true,
            selectableRows: 'none',
            selectableRowsHeader: false,
            print: false,
            download: data?.length > 0,
            viewColumns: false,
            textLabels: {
              body: {
                noMatch: 'Извините, данные отсутствуют',
              },
            },
          }}
        />
        <br />
        <MUIDataTable
          title={''}
          data={data?.aggregateParticipantsRankAndAwardByCalendar?.byEvent || []}
          columns={columnEvent}
          options={{
            filter: false,
            search: false,
            pagination: false,
            selectableRowsHideCheckboxes: true,
            selectableRows: 'none',
            selectableRowsHeader: false,
            print: false,
            download: data?.length > 0,
            viewColumns: false,
            expandableRows: true,
            textLabels: {
              body: {
                noMatch: 'Извините, данные отсутствуют',
              },
            },
            renderExpandableRow: (rowData: any, rowMeta) => {
              if (rowData[5]?.length === 0) {
                return null;
              }
              return (
                <td style={{ width: '100%' }} colSpan={4}>
                  <MUIDataTable
                    title={''}
                    data={rowData[5] || []}
                    columns={columnYear}
                    options={{
                      filter: false,
                      search: false,
                      pagination: false,
                      selectableRowsHideCheckboxes: true,
                      selectableRows: 'none',
                      selectableRowsHeader: false,
                      print: false,
                      download: data?.length > 0,
                      viewColumns: false,
                      textLabels: {
                        body: {
                          noMatch: 'Извините, данные отсутствуют',
                        },
                      },
                    }}
                  />
                </td>
              );
            },
          }}
        />
        <br />
        <MUIDataTable
          title={''}
          data={data?.aggregateParticipantsRankAndAwardByCalendar?.total || []}
          columns={columnYear}
          options={{
            filter: false,
            search: false,
            pagination: false,
            selectableRowsHideCheckboxes: true,
            selectableRows: 'none',
            selectableRowsHeader: false,
            print: false,
            download: data?.length > 0,
            viewColumns: false,
            textLabels: {
              body: {
                noMatch: 'Извините, данные отсутствуют',
              },
            },
          }}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default ClassificationUsers;
